import { render, staticRenderFns } from "./BackHomeBtn.vue?vue&type=template&id=6287b9e3&scoped=true"
import script from "./BackHomeBtn.vue?vue&type=script&lang=js"
export * from "./BackHomeBtn.vue?vue&type=script&lang=js"
import style0 from "./BackHomeBtn.vue?vue&type=style&index=0&id=6287b9e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6287b9e3",
  null
  
)

export default component.exports